import { useEffect } from "react";

import { useCurrentDate } from "../store/current-date/current-date.selectors";

import { useDispatchedActions } from "./use-dispatch-actions";

export const useSetCurrentDate = () => {
  const currentDate = useCurrentDate();

  const { setCurrentDate } = useDispatchedActions();

  useEffect(() => {
    if (!currentDate) {
      setCurrentDate(new Date().toISOString());
    }
    // eslint-disable-next-line
  }, [currentDate]);
};
